export const WEB_DOMAIN =
  process.env.REACT_APP_WEB_DOMAIN || 'https://web.aillia.motherapp.com';
export const DOWNLOAD_APP_DOMAIN =
  process.env.REACT_APP_DOWNLOAD_APP_DOMAIN ||
  'https://download.aillia.motherapp.cn';
export const CUSTOM_DEEP_LINK_SCHEMA = process.env.REACT_APP_CUSTOM_DEEP_LINK_SCHEMA || 'com.motherapp.aillia';
export const APP_NAME = process.env.REACT_APP_NAME || 'MA-Loyalty';
export const NO_LEVEL = process.env.REACT_APP_NO_LEVEL === 'true';
export const ONLY_HAVE_WEBSITE =
  process.env.REACT_APP_ONLY_HAVE_WEBSITE === 'true';
export const NO_SHOPIFY = process.env.REACT_APP_NO_SHOPIFY === 'true';
export const NO_WEB_APP = process.env.REACT_APP_NO_WEBAPP === 'true';
export const QRCODE_SHOW_RAW_MEMBERSHIP_ID =
  process.env.REACT_APP_QRCODE_SHOW_RAW_MEMBERSHIP_ID === 'true';
export const SHOPIFY_API_HOST =
  process.env.REACT_APP_SHOPIFY_API_HOST || 'https://ailliademo.myshopify.com';
export const NO_TRANSACTION_HISTORY = process.env.REACT_APP_NO_TRANSACTION_HISTORY === 'true';
export const SHOW_ONLINE_EMAIL_REMINDER = false;
export const MINIMUM_REGISTER_AGE = 18;
export const MAXIMUM_REGISTER_AGE = 150;

// support sign up method(s), have 3 options: "MOBILE_PHONE_NUMBER", "EMAIL_ADDRESS", "MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS"
export const PRIMARY_SIGN_UP_METHOD = "MOBILE_PHONE_NUMBER";
// LOGIN_EDITABLE have 3 options: "EDITABLE", "CONTACT_CUSTOMER_SERVICE", "UNEDITABLE"
export const LOGIN_EDITABLE = "CONTACT_CUSTOMER_SERVICE";
// if PRIMARY_SIGN_UP_METHOD is MOBILE_PHONE_NUMBER or EMAIL_ADDRESS, LOGIN_OPTIONAL would not work
export const LOGIN_OPTIONAL = false;
// if PRIMARY_SIGN_UP_METHOD is MOBILE_PHONE_NUMBER_AND_EMAIL_ADDRESS,
// SECOND_CONTACT_CONFIG, SECOND_CONTACT_EDITABLE and SECOND_CONTACT_HIDE_OTP would not work
// SECOND_CONTACT_CONFIG have 3 options: "DISABLE", "MANDATORY", "OPTIONAL"
export const SECOND_CONTACT_CONFIG = "MANDATORY";
// SECOND_CONTACT_EDITABLE have 3 options: "EDITABLE", "CONTACT_CUSTOMER_SERVICE", "UNEDITABLE"
export const SECOND_CONTACT_EDITABLE = "EDITABLE";
export const SECOND_CONTACT_HIDE_OTP = true;

export const CONTACT_US_EMAIL = "ct.tour@egltours.com";
export const CONTACT_US_PHONE = "+85236920888";
export const CONTACT_US_WHATSAPP_PHONE = "+85236920888";

// define if hide point to cash section
export const HIDE_POINT_TO_CASH_SECTION = true;

// open the website when click header logo
export const HEADER_LOGO_EXTRA_WEBSITE = process.env.HEADER_LOGO_EXTRA_WEBSITE || 'https://www.egltours.com/website/home';

// define if hide stamp rewards section
export const HIDE_STAMP_REWARDS_SECTION = true;

// the first is default language
export const SUPPORTED_LANGUAGE = ['zh-Hant'];

// define if hide reward claim section
export const HIDE_REWARD_CLAIM_SECTION = true;
